import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isBetween from 'dayjs/plugin/isBetween';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import objectSupport from 'dayjs/plugin/objectSupport';
import 'dayjs/locale/ru';

const datePlugin = dayjs;

datePlugin.locale('ru');
datePlugin.extend(customParseFormat);
datePlugin.extend(isSameOrBefore);
datePlugin.extend(isSameOrAfter);
datePlugin.extend(isBetween);
datePlugin.extend(localizedFormat);
datePlugin.extend(objectSupport);

export {
    datePlugin,
};

export default (_, inject) => {
    inject('datePlugin', datePlugin);
};
